import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
import landingRoutes from './routes/landing.routes'
import adminRoutes from './routes/admin.routes'
import assistantRoutes from './routes/assistant.routes'

Vue.use(Router)

const vueRouter = new Router({
  mode: 'history',

  // SE AGREGAN AL ARREGLO TODAS LAS RUTAS DEFINIDAS EN ./ROUTES
  routes: [...adminRoutes, ...assistantRoutes, ...landingRoutes],
  
  // SCROLLBEHAVIOR PERMITE IR A LA PARTE SUPERIOR DE LA PÁGINA CUANDO SE CAMBIA DE VISTA EN LA APP
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
});

// ACCIONES ANTES DE ENTRAR A CUALQUIER RUTA
vueRouter.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const isLogged = store.state.user.loggedIn;


  // SE OBTIENE EL TÍTULO DE CADA RUTA
  if (to.meta.title) {
    document.title = to.meta.title;
  }


  if (!isLogged) {
    localStorage.removeItem('USER_TOKEN');
  }
  if (!requiresAuth && isLogged && to.path === '/login') {
    return next('/')
  }
  if (requiresAuth && !isLogged) {
    next('/login')
  }

  // EN CASO DE ENTRAR A LA RUTA DE DETALLE DE EVENTO
  if (to.name === 'event-detail') {
    store.commit('user/enteringEventDetail');
  // EN CASO DE ENTRAR A LA PREVISUALIZACIÓN DE UN ADMINISTRADOR
  } else if (to.name === 'admin-new-event-preview') {
    store.commit('user/inEventPreview');
    // EN CASO DE DEJAR LA PREVISUALIZACIÓN DE UN EVENTO
  } else if (from.name === 'admin-new-event-preview') {
    store.commit('user/leavingEventPreview', true);
    store.commit('event/exitDarkMode');
  } else {
    store.commit('user/leavingEventPreview'); 
    store.commit('user/leavingEventDetail');
    store.commit('event/exitDarkMode');
  }
  next();
});

export default vueRouter;
